export default __webpack_public_path__ + "static/media/russianbgwindows.ca830e26.webp";